import { createSelector } from '@reduxjs/toolkit';
import { fetchStatuses } from '../../../constants/fetchStatuses';
import { ReducerState } from '../../store.types';

export const currencySelector = ({ currency }: ReducerState) => currency;
export const currencyLoadingSelector = createSelector(
  currencySelector,
  ({ fetchStatus }) => fetchStatus === fetchStatuses.pending,
);
